/**
 * Label + control + error message stack.
 * Pass labelClassName to fully control size/weight (e.g. AUTH_LABEL_CLASS = 22px / 500).
 */
export function FormField({
  label,
  htmlFor,
  error,
  children,
  className = '',
  labelClassName = '',
  required = false,
}) {
  return (
    <div className={`flex flex-col gap-2 text-left ${className}`}>
      {label && (
        <label
          htmlFor={htmlFor}
          className={`font-sf-pro-display ${
            labelClassName ||
            'text-text-secondary text-body sm:text-body-xl font-medium'
          }`}
        >
          {label}
          {required && <span className="text-status-error ml-0.5">*</span>}
        </label>
      )}
      {children}
      {error && (
        <span className="text-status-error text-sm font-medium">{error}</span>
      )}
    </div>
  );
}
